module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAPFJREFUSEvtlsENgzAMReNN2k3KELHErUwCnaTckJwluklZBLkKCijQoMiVSw+UK9F/zvc3BszOD+zMMwcDEtFd22IA6K21t0l3YSkRsTbQGNMj4jkJdM5dmPmkDUXENgnUBqX0DpZS51zNzFeptXEouq4bM1CWZZ+1NACbD4Bza4jo6ZM5DEOVgr71cKpQAo2FA9Df0kOLNVQ9NBFwrBkAms3Bl9xq66wYqGkpAFTW2kdc3MJSzdAgYpFNKRH5kail1sZj4TXiT9laSz00uWIPBgw9zLkieh8W8JzU3y7gb/xieDsQsfovYFEwJId3n8MXIadvHcw9Ww4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/expand.png
// module id = m/Cp
// module chunks = 3